var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2276_2267)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.23438H11.6471V7.41085H0V4.23438Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11719 0H9.52895V2.11765H2.11719V0Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4707 33.8828H33.8825V36.0005H26.4707V33.8828Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7061 14.8242H24.3531V18.0007H12.7061V14.8242Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3535 28.5879H36.0006V31.7644H24.3535V28.5879Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8231 25.9411C14.8231 27.4007 13.6356 28.5881 12.176 28.5881C10.7164 28.5881 9.52895 27.4007 9.52895 25.9411V9.5293H2.11719V25.9411C2.62302 39.2673 21.7313 39.2633 22.2348 25.9409V20.1175H14.8231V25.9411Z",
    fill: "#D71924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.236 9.52974C22.236 8.36207 23.186 7.41209 24.3536 7.41209C25.5213 7.41209 26.4713 8.36207 26.4713 9.52974V26.4709H33.883V9.52974C33.4039 -3.09525 15.3013 -3.09129 14.8242 9.52988C14.8242 9.52974 14.8242 12.7062 14.8242 12.7062H22.236V9.52974Z",
    fill: "#D71924"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2276_2267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon_01.cdffaa939c45bd1c32ad2706843e3d65.svg";
export { ForwardRef as ReactComponent };